module.exports = __webpack_public_path__ + "img/yyk.32f0448b.png";